// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimAction = t.struct({
    actionName: t.String,
    id: t.maybe(t.String),
    mode: t.String
}, {
    name: 'ClaimAction',
    strict: true
});

export const getDefaultState = () => new ClaimAction({
    actionName: '',
    id: '',
    mode: ''
});

export default ClaimAction;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-action.js